import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../App';
import axios from 'axios';
import { LoadingOverlay } from '../loading';
import ResetForm from './resetForm';

const ResetPasswordPage = () => {

  const { auth } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(true)
  const [valid, setValid] = useState(false)
  const [token, setToken] = useState('')
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    axios({
      method: 'post',
      url: '/api/validate_reset_token',
      data: {
        token: searchParams.get('token')
      }
    })
    .then(response => {
      setValid(response.data.valid)
      setToken(searchParams.get('token'))
      setIsLoading(false)
    })
    .catch(error => {
      setValid(false)
      setIsLoading(false)
    });
  }, [])

  if (!isLoading && !valid) {
    return navigate('/')
  }

  return (
    <div className="w-full flex min-h-lvh h-full">
      <div className="hero-bg absolute md:relative w-full min-h-lvh h-full md:h-auto">
        <div className="absolute w-full h-full bg-gradient-to-r from-indigo-500 to-emerald-500 rounded-2xl opacity-30"></div>
      </div>
      <div className="w-full justify-center flex items-center z-10 md:h-full md:min-h-lvh relative">
        <div className="p-8 sm:p-12 w-[80%] sm:w-[500px] bg-white h-fit my-[104px] lg:my-[106px] relative md:static">
          {isLoading ?
            <LoadingOverlay />
          :
            <ResetForm token={token} />}
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordPage
